import { gracefullyParseJson } from '../utils';
import { STATSIG_LAST_MODIFIED_CACHE_KEY } from './constants';

export function clearStaleStatsigCache(
  cutoff: Date,
  {
    storage = localStorage,
  }: {
    /**
     * Storage to use for clearing the stored stale Statsig cache values.
     * Defaults to the browser's `localStorage`.
     */
    storage?: Storage;
  } = {},
): [number | 'noop'] | [null, Error] {
  try {
    const lastModifiedTimes = storage.getItem(STATSIG_LAST_MODIFIED_CACHE_KEY);
    if (!lastModifiedTimes) return ['noop'];

    const lastModifiedTimesObj = gracefullyParseJson<Record<string, string>>(lastModifiedTimes) ?? {};
    let clearedCacheKeyCount = 0;
    for (const [key, lastModifiedTimeRaw] of Object.entries(lastModifiedTimesObj)) {
      const lastModifiedTime = parseInt(lastModifiedTimeRaw, 10);
      const isStaleStatsigCache = new Date(lastModifiedTime) < cutoff;
      if (isStaleStatsigCache) {
        storage.removeItem(key);
        clearedCacheKeyCount++;
      }
    }
    return [clearedCacheKeyCount];
  } catch (error) {
    return [null, error as Error];
  }
}
